import { ExternalHpaRedirectResponse } from '../../types';

const handle = ({ location }: ExternalHpaRedirectResponse) => new Promise<void>(() => {
  window.location.href = location;
});

export default {
  handle,
};
